<template>
	<div>
		<div class="total-results">
			<div class="total-results_header">
				<div class="total-results_command">
					<img :src="$hostname + match.home_image_ref" alt="">
					<span>{{ data.home_name }}</span>
				</div>
				<div class="total-results_heading">Друг против друга</div>
				<div class="total-results_command">
					<span>{{ data.away_name }}</span>
					<img :src="$hostname + match.away_image_ref" alt="">
				</div>
			</div>
			
			<div class="total-results_content">
				<div class="total-results_info">{{ data.games }} - матчей сыграно</div>
				
				<div class="total-results_row">
					<div class="total-results_col" v-if="sport !== 'tennis' && sport !== 'basketball'">
						<div class="total-results_item __1">{{ data.home_scores }}</div>
						<div class="total-results_text">Голы</div>
					</div>
					<div class="total-results_col">
						<div class="total-results_item __2" :class="isWinner(data.home_wins, data.away_wins, data.no_winner)">{{ data.home_wins }}</div>
						<div class="total-results_text">Победы</div>
					</div>
					<div class="total-results_col">
						<div class="total-results_item __3" :class="isWinner(data.no_winner, data.away_wins, data.home_wins)">{{ data.no_winner}}</div>
						<div class="total-results_text">Ничьи</div>
					</div>
					<div class="total-results_col">
						<div class="total-results_item __4" :class="isWinner(data.away_wins, data.no_winner, data.home_wins)">{{ data.away_wins }}</div>
						<div class="total-results_text">Победы</div>
					</div>
					<div class="total-results_col" v-if="sport !== 'tennis' && sport !== 'basketball'">
						<div class="total-results_item __5">{{ data.away_scores }}</div>
						<div class="total-results_text">Голы</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['data', 'sport', 'match'],
		
		methods: {
			isWinner(current, result1, result2) {
				if (current > result1 && current > result2) {
					return ['__transform'];
				}
				return [];
			}
		}
	}
</script>

<style scoped>

</style>